/** Autogenerated by public2business schematic. DO NOT CHANGE! */
/* tslint:disable */
export * from './tabs.module';
export * from './tab/tab.component';
export * from './tab/tab-content';
export * from './tabs/tabs.component';
